export default __webpack_public_path__ + "static/media/sellHome.ad0d9ce3.png";